import React, { FC } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { format } from 'date-fns';

import { CustomerIssue } from '../../model';

interface CustomerIssueDetailsProps {
  issue: CustomerIssue;
  showStatusChip?: boolean;
}

const CustomerIssueDetails: FC<CustomerIssueDetailsProps> = ({ issue, showStatusChip = true }) => {
  return (
    <Box>
      {showStatusChip && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Chip
            label={issue.is_resolved ? 'Resolved' : 'Open'}
            color={issue.is_resolved ? 'success' : 'warning'}
            size="small"
          />
        </Box>
      )}

      <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Issue Summary
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Customer:</strong> {issue.customer}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Opened:</strong> {issue.opened ? format(new Date(issue.opened), 'MM/dd/yyyy') : '-'} |{' '}
          <strong>Age:</strong> {issue.age} days
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Issue Type:</strong> {issue.issue_type || '-'} | <strong>Source:</strong> {issue.source || '-'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Assigned:</strong> {issue.assigned || 'Unassigned'} | <strong>Opened By:</strong> {issue.who || '-'} |{' '}
          <strong>Submitted By:</strong> {issue.submitter || '-'}
        </Typography>
        <Typography variant="body2">
          <strong>Issue:</strong> {issue.issue || 'No description'}
        </Typography>
        {issue.resolution && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            <strong>Resolution:</strong> {issue.resolution}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CustomerIssueDetails;
